import {
  removeQueryStringParam, parameters, smoothScroll, sendGoogleEvent,
} from '@html/_common/utils';
import CommonClpPopups from '../popups';

const EVENT_CATEGORY = 'CLP - ';

export default function AOClpMediaWithText() {
  const commonClpPopups = CommonClpPopups();
  let autoPopupOnUrl = false;

  const onClickVideo = (event, params) => {
    const $target = $(event.currentTarget);
    let $videoElement = $target.find('.js-ao-clp-youtube-video');
    const videoId = $videoElement.data('video');
    const eventCategory = $videoElement.data('event-category');
    let autoplay = $videoElement.data('autoplay') || 0;
    const isUserInteraction = params && params.isUserInteraction;
    const isOpenedInPopup = $videoElement.data('is-opened-in-popup') || 0;

    if (isUserInteraction) {
      autoplay = 0;
    }

    if (isOpenedInPopup) {
      if (parameters.is_mobile) {
        $target.click(() => commonClpPopups.openYoutubePopup('ao-clp-popup', videoId, autoplay));
      } else {
        commonClpPopups.openYoutubePopup('ao-clp-popup', videoId, autoplay);
      }
    } else {
      const $iframe = commonClpPopups.createIFrame('js-ao-clp-media-with-text__video-frame ao-clp-media-with-text__video-frame', videoId, autoplay);
      const $mediaWithText = $target.closest('.js-ao-clp-media-with-text');

      const isPrimaryButton = $videoElement.hasClass('js-ao-clp-media-with-text__cta');
      const $videoImageBox = $mediaWithText.find('.js-ao-clp-media-with-text__image-box--video');
      const $anchorLink = $mediaWithText.find('.aa-clp-id-anchor');

      if (isPrimaryButton) {
        $videoElement = $videoImageBox.find('.js-ao-clp-youtube-video');
      }

      const containsIFrame = !!$videoElement.find('.js-ao-clp-media-with-text__video-frame').length;
      if (!containsIFrame) {
        $videoElement.prepend($iframe);
      }

      if ($videoImageBox.length && !isUserInteraction) {
        smoothScroll({
          to: $anchorLink,
          duration: 200,
        });
      }
    }

    if (eventCategory && !isUserInteraction) {
      sendGoogleEvent(EVENT_CATEGORY + eventCategory, 'Play', videoId);
    }
  };

  const onClickPrimary = (event) => {
    sendGoogleEvent(`${EVENT_CATEGORY}Media With Text`, 'Click primary', $(event.currentTarget).text());
  };

  const onClickSecondary = (event) => {
    sendGoogleEvent(`${EVENT_CATEGORY}Media With Text`, 'Click secondary', $(event.currentTarget).text());
  };

  const initiate = () => {
    const $primary = $('.js-ao-clp-media-with-text__cta');
    const $secondary = $('.js-ao-clp-media-with-text__secondary-cta');

    if ($primary.length) $primary.click(onClickPrimary);

    if ($secondary.length) $secondary.click(onClickSecondary);

    const $videos = $('.js-ao-clp-youtube-video');
    if ($videos.length) {
      /*  Use: ?openvideo=int, (where int is number of video - 1)
        in URL to automatically open interactive block on page load. */
      const videoIdIndex = removeQueryStringParam('openvideo');

      if (videoIdIndex && !autoPopupOnUrl) {
        const videoId = $($videos[videoIdIndex]).data('video');
        commonClpPopups.openYoutubePopup('ao-clp-popup', videoId);
        autoPopupOnUrl = true;
      }

      $videos.each((index, element) => {
        $(element).parent().click(onClickVideo);
      });
    }
  };

  return { initiate };
}
